// extracted by mini-css-extract-plugin
module.exports = {"faqs":"Faqs-module__faqs___3GIl5","accordion-head":"Faqs-module__accordion-head___24WMv"};